/**
 * Correlation ID management for request tracing.
 *
 * A correlationId ties together all API calls within a single user flow
 * (e.g. "Create Document"). Call resetCorrelationId() when starting a
 * new user-initiated flow.
 *
 * See: docs/architecture/observability-ids.md
 */

function generateId(): string {
  // crypto.randomUUID() is available in all modern browsers and Node 19+
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for older environments
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

let currentCorrelationId: string = generateId();

/** Get the current correlation ID for this user flow. */
export function getCorrelationId(): string {
  return currentCorrelationId;
}

/** Generate a new correlation ID. Call when starting a new user flow. */
export function resetCorrelationId(): string {
  currentCorrelationId = generateId();
  return currentCorrelationId;
}
